export const ENV = process.env.REACT_APP_GS_ENV || 'local';
export const API_URL = process.env.REACT_APP_GS_API_URL || `http://localhost:8080`;
export const GRAPHQL_URL = API_URL + '/api/v1/graphql';
export const SCREEN_RATIO = 0.54;